import React, { useEffect, useState } from "react";
import {
  collection,
  query,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";
import { db } from "../firebaseConfig";

export default function TopViewedNews() {
  const [topNews, setTopNews] = useState([]);
  const [allNews, setAllNews] = useState([]);
  const [viewTab, setViewTab] = useState("top");

  useEffect(() => {
    const loadData = async () => {
      // Top 20
      const topQuery = query(
        collection(db, "news"),
        orderBy("views", "desc"),
        limit(20)
      );

      const topSnap = await getDocs(topQuery);

      setTopNews(
        topSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );

      // All News
    const allQuery = query(
  collection(db, "news"),
  orderBy("timestamp", "desc")
);

      const allSnap = await getDocs(allQuery);

      setAllNews(
        allSnap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
      );
    };

    loadData();
  }, []);

  const list = viewTab === "top" ? topNews : allNews;

  return (
    <div
      style={{
        background: "#fff",
        border: "1px solid #ddd",
        borderRadius: 6,
        overflow: "hidden",
      }}
    >
      {/* Header */}
      <div
        style={{
          background: "#8b0000",
          color: "#fff",
          padding: "10px 12px",
          fontSize: 20,
          fontWeight: "bold",
        }}
      >
        📊 নিউজ ভিউ
      </div>

      {/* Tabs */}
      <div
        style={{
          display: "flex",
          gap: 10,
          padding: 15,
          borderBottom: "1px solid #ddd",
        }}
      >
      <button
  onClick={() => setViewTab("top")}
  onMouseEnter={(e) => {
    if (viewTab !== "top") e.target.style.background = "#8b0000";
  }}
  onMouseLeave={(e) => {
    if (viewTab !== "top") e.target.style.background = "#ccc";
  }}
  style={{
    padding: "8px 18px",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    background: viewTab === "top" ? "#8b0000" : "#777",
    color: "#fff",
    fontWeight: "bold",
    transition: "0.25s",
  }}
>
  🏆 সর্বাধিক পঠিত
</button>

       <button
  onClick={() => setViewTab("all")}
  onMouseEnter={(e) => {
    if (viewTab !== "all") e.target.style.background = "#8b0000";
  }}
  onMouseLeave={(e) => {
    if (viewTab !== "all") e.target.style.background = "#ccc";
  }}
  style={{
    padding: "8px 18px",
    border: "none",
    borderRadius: 4,
    cursor: "pointer",
    background: viewTab === "all" ? "#8b0000" : "#777",
    color: "#fff",
    fontWeight: "bold",
    transition: "0.25s",
  }}
>
  📋 সকল নিউজ
</button>
      </div>



      {/* Title */}
      <div
        style={{
          padding: "12px 18px",
          fontWeight: "bold",
          fontSize: 18,
        }}
      >
        {viewTab === "top"
          ? "🏆 সর্বাধিক পঠিত ২০টি সংবাদ"
          : `📋 সকল সংবাদ (${allNews.length})`}
      </div>

      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr
            style={{
              background: "#f5f5f5",
              borderBottom: "2px solid #ddd",
            }}
          >
            <th
              style={{
                width: 70,
                padding: 12,
                textAlign: "center",
              }}
            >
              #
            </th>



<th
  style={{
    width: 140,
    padding: 12,
    textAlign: "center",
  }}
>
  প্রকাশের তারিখ
</th>


            <th
              style={{
                padding: 12,
                textAlign: "left",
              }}
            >
              শিরোনাম
            </th>

            <th
              style={{
                width: 130,
                padding: 12,
                textAlign: "center",
              }}
            >
              Views
            </th>
          </tr>
        </thead>

        <tbody>
          {list.map((item, index) => (
            <tr
              key={item.id}
              style={{
                borderBottom: "1px solid #eee",
              }}
            >
     <td
  style={{
    padding: 12,
    textAlign: "center",
    fontWeight: "bold",
    color: "#8b0000",
  }}
>
  {index + 1}
</td>

<td
  style={{
    padding: 12,
    textAlign: "center",
    whiteSpace: "nowrap",
    fontSize: 14,
  }}
>
  {item.timestamp
    ? (item.timestamp.toDate
        ? item.timestamp.toDate().toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
        : new Date(item.timestamp).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          }))
    : "-"}
</td>

<td
  style={{
    padding: 12,
    lineHeight: 1.7,
    fontSize: 16,
  }}
>
                <a
                  href={`/${item.categorySlug}/${item.subcategorySlug}/${item.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "#222",
                    textDecoration: "none",
                    fontWeight: 500,
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.color = "#8b0000";
                    e.target.style.textDecoration = "underline";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.color = "#222";
                    e.target.style.textDecoration = "none";
                  }}
                >
                  {item.title}
                </a>
              </td>

              <td
                style={{
                  padding: 12,
                  textAlign: "center",
                  fontWeight: "bold",
                  color: "#8b0000",
                  fontSize: 16,
                }}
              >
                {(item.views || 0).toLocaleString()}
              </td>
            </tr>
          ))}

          {list.length === 0 && (
            <tr>
              <td
                colSpan={4}
                style={{
                  padding: 40,
                  textAlign: "center",
                  color: "#777",
                }}
              >
                কোনো তথ্য পাওয়া যায়নি।
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}